module.exports = __webpack_public_path__ + "img/discount.e1a06578.svg";